export const calendar = {
  title: 'Calendar View',
  subtitle: 'Visual overview of your bookings',
  
  // Navigation
  previousMonth: 'Previous Month',
  nextMonth: 'Next Month',
  
  // Days of week
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  
  // Short days
  sun: 'Sun',
  mon: 'Mon',
  tue: 'Tue',
  wed: 'Wed',
  thu: 'Thu',
  fri: 'Fri',
  sat: 'Sat',
  
  // Months
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  
  // Booking details
  bookingDetails: 'Booking Details',
  customer: 'Customer',
  vehicle: 'Vehicle',
  pickup: 'Pickup',
  return: 'Return',
  duration: 'Duration',
  totalAmount: 'Total Amount',
  
  // Messages
  noBookings: 'No bookings for this month',
  moreBookings: '+{{count}} more',
}; 